import React from 'react'

const FeedbackList = () => {
  return (
    <div>
      
    </div>
  )
}

export default FeedbackList
